export const isFootballSport = (sport) => ["NFL", "CFB"].includes(String(sport || "").toUpperCase());
export const supportsDqs = (sport) => !["NFL", "CFB", "NHL"].includes(String(sport || "").toUpperCase());

export const observedGridNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export function footballResearchDelta(row) {
  for (const key of ["L10 Delta", "L5 Delta", "Season Delta"]) {
    const value = observedGridNumber(row?.[key]);
    if (value !== null) return { value, source: key };
  }
  return { value: null, source: null };
}

export function gridDeltaValue(row, sport) {
  if (isFootballSport(row?.Sport || sport)) return footballResearchDelta(row).value;
  return observedGridNumber(row?.DELTA ?? row?.Delta ?? row?.delta ?? row?.["Delta"]);
}

export function defenseRankValue(row) {
  return observedGridNumber(row?.["Opponent Defense Rank"]);
}

export function defenseRankLabel(row) {
  const rank = defenseRankValue(row);
  return rank === null ? "—" : `#${rank}`;
}

export function compareNullableNumbers(a, b, direction = "asc") {
  const left = observedGridNumber(a);
  const right = observedGridNumber(b);
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  return direction === "desc" ? right - left : left - right;
}
